import { Modal } from 'react-bootstrap';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export const CfModal = ({
  show,
  showCloseIcon,
  title,
  children,
  onCancel,
  cancelButtonText,
  hideCancelButton,
  onConfirm,
  confirmButtonText,
  hideConfirmButton,
  disableConfirmButton,
}) => (
  <Modal
    show={show}
    onHide={onCancel}
    dialogClassName={cx('cf-modal')}
    centered
  >
    <div className={cx('cf-modal-inner')}>
      {showCloseIcon && (
        <FontAwesomeIcon className={cx('close')} icon={faXmark} onClick={onCancel} />
      )}
      {!!title && (
        <h3 className={cx('title')}>{title}</h3>
      )}
      <div className={cx('body')}>
        {children}
      </div>
      {(!hideCancelButton || !hideConfirmButton) && (
        <div className={cx('control-buttons')}>
          {!hideCancelButton && (
            <button type="button" className={cx('cancel')} onClick={onCancel}>
              {cancelButtonText}
            </button>
          )}
          {!hideConfirmButton && (
          <button
            type="button"
            className={cx('confirm')}
            onClick={onConfirm}
            disabled={disableConfirmButton}
          >
            {confirmButtonText}
          </button>
          )}
        </div>
      )}
    </div>
  </Modal>
);

CfModal.propTypes = {
  show: PropTypes.bool,
  showCloseIcon: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
  onCancel: PropTypes.func,
  cancelButtonText: PropTypes.string,
  hideCancelButton: PropTypes.bool,
  onConfirm: PropTypes.func,
  confirmButtonText: PropTypes.string,
  hideConfirmButton: PropTypes.bool,
  disableConfirmButton: PropTypes.bool,
};

CfModal.defaultProps = {
  show: false,
  showCloseIcon: true,
  title: null,
  children: null,
  onCancel: () => null,
  cancelButtonText: 'Cancel',
  hideCancelButton: false,
  onConfirm: () => null,
  confirmButtonText: 'Confirm',
  hideConfirmButton: false,
  disableConfirmButton: false,
};

export default withComponentName(CfModal);
